import React, { useEffect, useState } from "react";
import Barcode from "react-barcode";
import constants from "../../../constants/constants";
import moment from "moment";
import { Button } from "react-bootstrap";

const PrintLabels = () => {
    const [state, setState] = useState<any>(null);

    useEffect(() => {
        try {
            const windowName = window.name;
            const state = JSON.parse(windowName);

            setState(state);
        } catch (error) {
            console.error('Failed to parse state from window name', error);
        }
    }, []);

    return (
        <React.Fragment>
            <div className='text-center hide-on-print py-3'>
                <Button className='custom-min-width-85' size='sm' variant="dark" onClick={() => window.print()}>Print</Button>
            </div>

            <table
                className="print-labels-table"
                aria-label="Print Labels"
                style={{
                    width: '3in',
                    margin: '0 auto',
                    border: 'none',
                    borderSpacing: 0,
                    borderCollapse: 'collapse',
                    fontSize: 8,
                    lineHeight: 1,
                    textAlign: 'center',
                    pageBreakInside: 'avoid',
                }}
            >
                <tbody>
                    {state?.quantity && Array.from({ length: state.quantity }).map((_, i) => (
                        <tr key={i}>
                            <td style={{verticalAlign: 'middle', border: '1px solid #000', padding: '0px 8px 2px', height: '1in'}}>
                                {state?.fnsku && (
                                    <div style={{ height: '45px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Barcode
                                            value={state?.fnsku}
                                            width={1.7}
                                            height={18}
                                            format={"CODE128"}
                                            displayValue={true}
                                            fontSize={10}
                                        />
                                    </div>
                                )}
                                <p style={{ margin: 0, padding: 0, textAlign: 'left', fontSize: 8, maxWidth: '2.8in', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', lineHeight: "normal" }}>
                                    {state?.product_name}
                                </p>
                                <div style={{ width: '100%', float:"left", lineHeight: "normal" }}>
                                    <span style={{ margin: 0, padding: 0, textAlign: 'left', float:"left" }}>
                                        <b style={{paddingRight: '4px', display: 'inline-block', verticalAlign: 'top'}}>{state?.labelType === "new" ? "New " : "Used "}</b>
                                        {state?.listing_sku && <b style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: state?.expiration_date ? '1.75in' : '2.6in', display: 'inline-block', verticalAlign: 'top'}}>{state?.listing_sku}</b>}
                                    </span>
                                    {state?.expiration_date && (
                                    <span style={{ margin: 0, padding: 0, textAlign: 'right', float:"right", fontWeight: 'bold' }}>
                                        exp: {moment(state?.expiration_date).format(constants.datetimeFormats.date)}
                                    </span>
                                )}
                                </div>
                                
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {/* Inline print styles */}
            <style>{`
                @media print {
                    @page {
                        size: 3in 1in;
                        margin: 0;
                    }
                    .print-labels-table td{
                        border:0 !important;
                    }
                }`}
            </style>
        </React.Fragment>
    );
}

export default PrintLabels;